module.exports = __webpack_public_path__ + "static/img/img-company-card.c32f76e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auth/img-company-card.png
// module id = krA1
// module chunks = 36